import React from 'react';

/**
 * Displays removable pills for active filters plus an optional "Clear all" action.
 *
 * @param {Object} props
 * @param {{ key: string, label: string }[]} props.pills
 * @param {(key: string) => void} [props.onRemovePill]
 * @param {() => void} [props.onClearAll]
 */
const AppliedFilters = ({ pills = [], onRemovePill, onClearAll }) => {
  if (!pills.length) {
    return null;
  }

  return (
    <div className="rt-applied-filters">
      {pills.map(pill => (
        <span key={pill.key} className="rt-applied-filter-pill">
          <span className="rt-applied-filter-pill-label">{pill.label}</span>
          {onRemovePill && (
            <button
              type="button"
              className="rt-applied-filter-pill-remove"
              onClick={() => onRemovePill(pill.key)}
              aria-label={`Remove ${pill.label}`}
            >
              ×
            </button>
          )}
        </span>
      ))}
      {onClearAll && (
        <button
          type="button"
          className="rt-applied-filter-pill rt-applied-filter-pill--clear-all"
          onClick={onClearAll}
          aria-label="Clear all filters"
        >
          <span className="rt-applied-filter-pill-label">Clear all</span>
          <span className="rt-applied-filter-pill-clear-icon" aria-hidden="true">×</span>
        </button>
      )}
    </div>
  );
};

export default AppliedFilters;
